module.exports = __webpack_public_path__ + "img/sidebar-voucher.e7be814.svg";